import { Center, Text, CenterProps } from '@chakra-ui/react';

type DisableProps = {
  day: number;
} & CenterProps;

export default function Disable({ day, ...props }: DisableProps) {
  return (
    <Center py={4} {...props}>
      <Text color="gray.400" fontWeight="bold">
        {day}
      </Text>
    </Center>
  );
}
